const NewChargeIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 19V6.55556C6 6.143 6.18061 5.74733 6.5021 5.45561C6.82359 5.16389 7.25963 5 7.71429 5H16.2857C16.7404 5 17.1764 5.16389 17.4979 5.45561C17.8194 5.74733 18 6.143 18 6.55556V19L15.4286 17.4444L13.7143 19L12 17.4444L10.2857 19L8.57143 17.4444L6 19Z"
      stroke="#447AED"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 12.5021C10 13.3324 10.5988 14 11.3333 14H12.8343C13.473 14 13.992 13.418 13.992 12.6904C13.992 11.9116 13.6727 11.6291 13.2016 11.4494L10.7984 10.5506C10.3273 10.3709 10.008 10.097 10.008 9.30956C10.008 8.59058 10.5269 8 11.1657 8H12.6667C13.4012 8 14 8.66762 14 9.49786"
      stroke="#447AED"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 7V15"
      stroke="#447AED"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default NewChargeIcon;
